import { Box, Text } from '@chakra-ui/react';

const ELEVATED_SHADOW = '0 5px 15px 0 rgba(0, 0, 0, 0.18)';

export interface LocationTagProps {
  children: React.ReactNode;
  elevated?: boolean;
  /** When true, tag is full width with square top corners and 6px bottom radius; use when anchored to bottom of a container (e.g. image) */
  imageTag?: boolean;
}

export function LocationTag({ children, elevated = false, imageTag = false }: LocationTagProps) {
  return (
    <Box
      display={imageTag ? 'flex' : 'inline-flex'}
      alignItems="center"
      justifyContent="center"
      px="2"
      py="1.5"
      w={imageTag ? 'full' : undefined}
      borderRadius="full"
      borderTopLeftRadius={imageTag ? 0 : undefined}
      borderTopRightRadius={imageTag ? 0 : undefined}
      borderBottomLeftRadius={imageTag ? '6px' : undefined}
      borderBottomRightRadius={imageTag ? '6px' : undefined}
      bg="brand.200"
      color="brand.700"
      boxShadow={elevated ? ELEVATED_SHADOW : undefined}
    >
      <Text variant={imageTag ? 'SmallBodyMedium' : 'ExtraSmallBodyDemiBold'}>{children}</Text>
    </Box>
  );
}
